import { useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { Button1 } from "../Components";

const ComingSoon = ({ feature = "This feature", navName = "Coming Soon" }) => {
  const navigate = useNavigate();

  return (
    <MainLayout
      NavName={navName}
      expand={false}
      pageClassName="dashboard-page coming-soon-page"
      contentClassName="dashboard-content"
    >
      <div
        className="d-flex flex-column align-items-center justify-content-center text-center"
        style={{ minHeight: "60vh", padding: "24px" }}
      >
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            width: 88,
            height: 88,
            borderRadius: "50%",
            background: "#e8f9f1",
            marginBottom: 24,
          }}
        >
          <span style={{ fontSize: 40 }} role="img" aria-label="rocket">
            {"\u{1F680}"}
          </span>
        </div>

        <span
          className="fw-semibold"
          style={{
            color: "#1bbb6b",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            fontSize: 12,
            marginBottom: 8,
          }}
        >
          Coming soon
        </span>

        <h2 className="fw-bold" style={{ color: "#0a332a", maxWidth: 460 }}>
          {feature} is on the way
        </h2>

        <p style={{ color: "#4c5e59", maxWidth: 440, marginTop: 8 }}>
          We are putting the finishing touches on this. For now, send money
          across borders from your dashboard.
        </p>

        <div className="d-flex gap-2 mt-4 flex-wrap justify-content-center">
          <Button1
            buttonName="Send money"
            className="btn-dark"
            onClick={() => navigate("/new-transfer")}
          />
          <Button1
            buttonName="Back to dashboard"
            className="border"
            onClick={() => navigate("/dashboard")}
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default ComingSoon;
